<div class="controls-container">
    <div class="controls-header">List Box {{ListBoxSelectedItemName}}</div>
    <pm-list-box [ItemsSource]="ItemsSource" 
                 [ItemTemplate]="ItemTemplate"
                 ItemHeight="30"
                 [(SelectedItem)]="ListBoxSelectedItem">
        <ng-template #ItemTemplate let-item>
            <div class="list-box-item-template">{{item.Name}}</div>
        </ng-template>
    </pm-list-box>
    
    <!-- <pm-properties [Item]="BreadcrumbControl"></pm-properties> -->

    <div class="controls-header">List Box Custom Template</div>
    <pm-list-box [ItemsSource]="ItemsSource"                 
                 [ItemTemplate]="CheckBoxItemTemplate"
                 [(SelectedItem)]="CheckBoxSelectedItem">
        <ng-template #CheckBoxItemTemplate
                        let-item>
            <div class="layout-center" style="height: 100%">
                <div style="padding-left: 18px">
                    <div style="font-style:oblique; font-size: 16px; font-weight: 600; margin: 4px; padding: 2px 20px; min-width: 150px; justify-content: center; display: flex;" [style.background-color]="BackgroundColor(item)">{{item.Name}}</div>
                </div>
                <div class="flex-align-right" *ngIf="IsSelected(item)">
                    <pm-icon-check IconClass="icon-green"></pm-icon-check>
                </div>
            </div>
        </ng-template>
    </pm-list-box>

    <!-- <pm-properties [Item]="BreadcrumbControl"></pm-properties> -->
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/list-box/list-box.html